import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../../App';
import rightImage from '../../Assets/OurServices/rightservice.png';

const ServiceSection = ({ isArabic, isReverse, title, description, customTranslateY }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );
    if (currentRef) observer.observe(currentRef);
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return (
    <div 
      ref={sectionRef}
      className={`flex flex-col items-center w-full lg:flex-row ${isReverse ? 'lg:flex-row-reverse' : ''}`}
      dir={isArabic ? "rtl" : "ltr"}
    >
      <div 
        className="relative shrink-0 flex items-center justify-center z-30 group cursor-pointer transition-transform duration-500 hover:scale-105" 
        style={{ width: '318px', height: '318px' }}
      >
        <div className="w-full h-full rounded-full border-[33px] border-[#2EBCE2] opacity-100 transition-all duration-500 group-hover:border-[#1A4D90] group-hover:shadow-[0_0_30px_rgba(46,188,226,0.5)]"></div>
        
        <h3 className="absolute text-white font-alexandria font-semibold text-[25px] leading-[54px] tracking-[-2%] text-center uppercase w-[143px] transition-all duration-500 group-hover:text-[#2EBCE2] group-hover:scale-110">
          {title}
        </h3>
      </div>

      <div className={`relative flex flex-col w-full items-center 
        ${isReverse 
          ? (isArabic ? 'lg:items-end lg:ml-[-10px] lg:mt-[-80px]' : 'lg:items-end lg:mr-[-10px] lg:mt-[-145px]') 
          : (isArabic ? 'lg:items-start lg:mr-[-2.7px] lg:mt-[-95px]' : 'lg:items-start lg:ml-[-1.5px] lg:mt-[-130px]')
        }`}
      >
        <div className="z-20 mt-6 lg:mt-0 lg:mb-[-5px]">
          <p className={`
            text-[#FFFFFF99] font-alexandria font-light text-[20px] leading-[46px] uppercase max-w-[713px] drop-shadow-lg
            text-center 
            ${isArabic ? 'lg:text-right' : 'lg:text-left'}
            ${isVisible ? 'animate-slow-fall' : 'opacity-0'}
          `}>
            {description}
          </p>
        </div>
        
        <div 
          className="hidden lg:block h-[46px] w-full max-w-[682px] z-10 transition-transform" 
          style={{ 
            background: (isReverse ? !isArabic : isArabic) 
              ? 'linear-gradient(270deg, #2EBCE2 2.91%, #030B15 99.86%)' 
              : 'linear-gradient(90deg, #2EBCE2 2.91%, #030B15 99.86%)',
            transform: isArabic && customTranslateY ? `translateY(${customTranslateY})` : 'none'
          }}
        ></div>
      </div>
    </div>
  );
};

const OurServices = () => {
  const { t, language } = useLanguage();
  const isArabic = language === 'ar';

  const styles = `
    @keyframes slowFallDown {
      0% { transform: translateY(-60px); opacity: 0; }
      100% { transform: translateY(0); opacity: 1; }
    }
    .animate-slow-fall {
      animation: slowFallDown 1.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
    }
  `;

  return (
    <div key={language} className="relative w-full bg-[#030B15] overflow-hidden py-8 mb-50 lg:min-h-screen flex flex-col justify-center">
      <style>{styles}</style>
      
      <img 
        src={rightImage} 
        alt="" 
        className="absolute z-10 hidden xl:block pointer-events-none"
        style={{ 
          width: '1450px', height: '520px', objectFit: 'contain',
          top: '+30px', [isArabic ? 'left' : 'right']: '-550px', 
          transform: isArabic ? 'scaleX(-1)' : 'none', maxWidth: 'none' 
        }}
      />

      <div className="relative z-20 w-full max-w-[1232px] mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-[#1A4D90] font-alexandria font-medium text-[20px] md:text-[25px] mb-2">
            {t('servicesPage.services')}
          </h1>
          <h2 className="text-white font-alexandria font-medium text-[28px] md:text-[31px] mb-6">
            {t('servicesPage.subtitle')}
          </h2>
          <p className="text-[#CFCFCF] font-alexandria font-light text-[18px] md:text-[22px] leading-[32px] max-w-[1231px] mx-auto opacity-90 text-center">
            {t('servicesPage.description')}
          </p>
        </div>

        <div className="space-y-12 lg:space-y-4">
          <ServiceSection isArabic={isArabic} isReverse={false} title={t('hero.walletSolutions')} description={t('hero.walletDesc')} customTranslateY="2px" />
          <ServiceSection isArabic={isArabic} isReverse={true} title={t('hero.tradingPlatform')} description={t('hero.tradingDesc')} />
          <ServiceSection isArabic={isArabic} isReverse={false} title={t('hero.marketInsights')} description={t('hero.marketDesc')} customTranslateY="19px" />
          <ServiceSection isArabic={isArabic} isReverse={true} title={t('hero.customerSupport')} description={t('hero.supportDesc')} />
        </div>
      </div>
    </div>
  );
};

export default OurServices;